function configuratorFormSubmitHandler(event) {
  event.preventDefault();
  $('#' + event.target.id + ' #configurator-form-submit').prop('disabled', true)
  $('#' + event.target.id + ' .submit-text').hide();
  $('#' + event.target.id + ' .submit-in-progress').show();

  var formData = new FormData(event.currentTarget);
  var _successURL = formData.get('_successURL') || "";
  var email = formData.get('Customer Email') || "";
  var _subject = formData.get('_subject') || "";
  var _model = formData.get('_model') || "";
  var tank_colour = formData.get('Tank Colour') || "";
  var seat_colour = formData.get('Seat Colour') || "";
  // var embossed_seat = formData.get('Embossed seat') || ""; // Need to change this
  // var hand_stitched_seat = formData.get('Hand-Stitched Seat') || ""; // Need to change this
  var seat_type = formData.get('Seat Product') || "";
  var mudguard_colour = formData.get('Mudguard Colour') || "";
  var suspension = formData.get('K-Tech Razor Lite Suspension') || "";
  var extras = formData.get('Extra Products') || "";
  var storage = formData.get('Maeving Roll Top Pannier') || "";
  var tracker = formData.get('GPS Security Tracker') || "";
  var finance = formData.get('Finance') || "";
  var base_sku = formData.get('Base SKU') || "";
  var sku = formData.get('SKU') || "";

  var _content = [
    _model,
    tank_colour,
    seat_colour,
    seat_type,
    suspension,
    extras,
    storage,
    tracker,
    finance,
    base_sku,
    sku,
  ].join(', ');

  console.log("Configurator email", email)
  console.log("Configurator subject", _subject)
  console.log("Configurator _content", _content)
  console.log("Configurator _model", _model)
  console.log("Configurator tank_colour", tank_colour)
  console.log("Configurator seat_colour", seat_colour)
  console.log("Configurator seat_type", seat_type)
  console.log("Configurator mudguard_colour", mudguard_colour)
  console.log("Configurator suspension", suspension)
  console.log("Configurator extras", extras)
  console.log("Configurator storage", storage)
  console.log("Configurator tracker", tracker)
  console.log("Configurator finance", finance)
  console.log("Configurator base_sku", base_sku)
  console.log("Configurator sku", sku)

  var data = {
    // "submittedAt": "1517927174000",
    "fields": [
      {
        "objectTypeId": "0-1",
        "name": "email", // Single line text
        "value": email,
      },
      {
        "objectTypeId": "0-5",
        "name": "subject", // Single line text
        "value": _subject,
      },
      {
        "objectTypeId": "0-5",
        "name": "content", // Multi line text
        "value": _content,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___model", // Single line text
        "value": _model,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___tank_colour", // Single line text
        "value": tank_colour,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___seat_colour", // Single line text
        "value": seat_colour,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___seat_type", // Single line text
        "value": seat_type,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___mudguards", // Single line text
        "value": mudguard_colour,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___suspension", // Single line text
        "value": suspension,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___extras", // Single line text
        "value": extras,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___storage", // Single line text
        "value": storage,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___tracker", // Single line text
        "value": tracker,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___finance", // Single line text
        "value": finance,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___base_sku", // Single line text
        "value": base_sku,
      },
      {
        "objectTypeId": "0-5",
        "name": "pre_order_lock___sku", // Single line text
        "value": sku,
      },
    ],
  };
  
  // Define the URL for the request
  var url = 'https://api.hsforms.com/submissions/v3/integration/submit/27038846/cb0a24c8-305b-4215-9073-72cc94e44bfc';
  var final_data = JSON.stringify(data);
  
  // Use the Fetch API to send the request
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: final_data
  })
  .then(response => {
    if (response.ok) {
      return response.text();
    } else if (response.status === 400) {
      return Promise.reject('400 error: The submission was rejected.');
    } else if (response.status === 403) {
      return Promise.reject('403 error: The portal isn\'t allowed to post submissions.');
    } else if (response.status === 404) {
      return Promise.reject('404 error: The formGuid wasn\'t found.');
    } else {
      return Promise.reject(`Error: ${response.statusText}`);
    }
  })
  .then(responseText => {
    console.log("Success!", responseText)
    $('#' + event.target.id + ' .submit-text').show();
    $('#' + event.target.id + ' .submit-in-progress').hide();
    $('#' + event.target.id + ' #configurator-form-submit').prop('disabled', false)
    window.location.href = _successURL;
  })
  .catch(error => {
    console.log("Error!", error)
    $('#' + event.target.id + ' .submit-text').show();
    $('#' + event.target.id + ' .submit-in-progress').hide();
    $('#' + event.target.id + ' #configurator-form-submit').prop('disabled', false)
  });
}